import { ClosedCaseVisibility } from '../enums/closed-case-visibility.enum';
import { InvestigationTypeEntity } from './investigation-type.entity';

export class InvestigationTypeDetailEntity extends InvestigationTypeEntity {
  constructor(
    id: string,
    name: string,
    description: string,
    categoryId: string,
    categoryName: string,
    isActive: boolean,
    sortOrder: number,
    checklistDisplayOnCases: boolean,
    closedCaseVisibility: ClosedCaseVisibility,
    readonly createdOn: string,
    readonly updatedOn: string,
    hasPublishedForm = false,
  ) {
    super(id, name, description, categoryId, categoryName, isActive, sortOrder, checklistDisplayOnCases, closedCaseVisibility, hasPublishedForm);
  }
}
